// IAB returns a big block of string that looks like this...
//
//    This is a list title\n
//      * This is a list item\n
//      * Another list item\n
//      *Some also look like this without proper spacing..\n
//      *Because why not?\n
//      ● Oh hey another "icon"\n
//      ● Because again, why not?\n
//
//
// We can't show asterisk-led list to our users because it's not fashionable if
// not an abomination to our users experience.
//
// This fn parses that IAB description string and returns an object with
// culture and structure so we can identify which ones are titles and which
// ones belong to a list.

interface DescriptionMap {
  [key: number]: Array<string>;
}

interface TitleMap {
  [key: number]: string;
}

export function parseIABDescription(
  description: string
): [TitleMap, DescriptionMap] {
  const texts = description.split('\n').map((d) => d.trim());

  const lists = {} as DescriptionMap;
  const titles = {} as TitleMap;

  let section = 0;

  for (const text of texts) {
    if (text.trim() === '') {
      continue;
    }

    const encodedText = encodeURIComponent(text);

    if (!text.startsWith('*') && !encodedText.startsWith('%E2%97%8F')) {
      section = section + 1;
      titles[section] = text;
      continue;
    }

    if (!lists[section]) {
      lists[section] = [];
    }

    const listText = text.substring(1).trim();
    lists[section].push(listText);
  }

  return [titles, lists];
}
